const admininfor = {
    state: {
        // token: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : '',
        admin: {
            islogin: false,
            id: 0,
            name: "",
            email: "",
        }
    },
    getters: { //

    },
    mutations: {
        changadmininfor(state, data) { //修改用户信息
            var infor = state.admin;
            if (!data) {
                for (let key in infor) {
                    infor[key] = "";
                }
                infor.islogin = false;
                state.token = "";
            } else {
                for (let key in infor) {
                    infor[key] = data[key];
                }
                infor.islogin = true;
                // state.token = ;
            }
        },
    },
    actions: {
        // Action 提交的是 mutation，而不是直接变更状态


    },
    module: {

    }
}
export default admininfor;


// WEBPACK FOOTER //
// ./src/store/admin.js